import { createSlice, createSelector } from '@reduxjs/toolkit'

const initialState = {
  brands: [],
  seo: {},
  loading: false,
  error: null,
}

const profile = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    requestBrands(state) {
      state.loading = true
    },
    successBrands(state, { payload }) {
      state.loading = false
      state.error = null
      state.brands = payload?.brands
      state.seo = payload?.seo || {};
    },
    failureBrands(state, { payload }) {
      state.loading = false
      state.error = payload?.data
    }
  }
})

export const fetchBrands = () => async (dispatch, getState, { api }) => {
  try {
    dispatch(requestBrands())
      const response = await api.brands()
      const { result, brands, seo } = response
      if (result === 'success') {
        dispatch(successBrands({ brands, seo }))
      } else {
        dispatch(failureBrands({ data: response }))
      }    
  } catch(e) {
    dispatch(failureBrands({ data: e.toString() }))
  }
}

export const getBrands = createSelector(
  state => state.profile,
  profile => profile.brands
)

export const { requestBrands, successBrands, failureBrands } = profile.actions

export default profile.reducer
